import * as moment from 'moment';

import { ICalendarState, IMonth } from "../../classes/calendar";
import { IEvent } from '../../custom/classes/event';
import CalendarApi from "../../common/calendar-api";
import { ICalendarAppState } from "..";
import { updateEvents, requestEvents, eventError, updateUpNext } from './calendar.actions';
import { create } from '../../common/calendar';
import { requestText, receiveText, errorApiText } from './calendar-text.actions';
import { requestPromoCodeApply, errorPromoCodeApply, receivePromoCodeApplyResponse } from './promo-code.actions';

/**
 * Generate a key using the input date object.
 * @param date
 */
function generateKey(date: moment.Moment) {
    return `${date.year().toString()},${date.month().toString()}`
}

/**
 * Dispatch this action to get the latest set of events from the API.
 */
export function getEventsFromApi() {
    return (dispatch, getState: () => ICalendarAppState) => {
        const currState = getState();

        if (!currState.calendar.updating) {
            dispatch(requestEvents());
        }

        return CalendarApi.getEvents(currState.calendar, currState.calendarSettings).then(events => {
            const filteredEvents = events.filter(currState.calendar.filterFunction);

            // Contains all of the events categorized by the month it lives in.
            let byMonth: { [month: string]: IEvent[] } = {};

            filteredEvents.forEach(event => {
                const momentObj = moment(event.eventDate);

                if (currState.calendarSettings.loadWrappingMonthDates) {
                    const startOfWeek = momentObj.clone().startOf("week");

                    /*
                     * If the month idx of the first day of the week is larger, it's next month. This is
                     * also true if the end of the week is in the next year.
                     */
                    if ((startOfWeek.month() < momentObj.month() || startOfWeek.year() < momentObj.year())) {
                        const secondMonth = momentObj.clone().subtract(1, "month");

                        if (generateKey(secondMonth) in byMonth) {
                            byMonth[generateKey(secondMonth)].push(event);
                        } else {
                            byMonth[generateKey(secondMonth)] = [event];
                        }
                    }
                }

                if (generateKey(momentObj) in byMonth) {
                    byMonth[generateKey(momentObj)].push(event);
                } else {
                    byMonth[generateKey(momentObj)] = [event];
                }
            });

            // Create an array for all months between the start and the end date. This is to fill in "missing" months.
            let allMonths: Array<moment.Moment> = [];
            for (let i = currState.calendar.startDate.clone(); i.isBefore(currState.calendar.endDate); i.add(1, "month")) {
                allMonths.push(i.clone());
            }

            const monthsToEvents: IMonth<IEvent>[] = allMonths.map(monthMoment => {
                let evts = byMonth[generateKey(monthMoment)];

                // Don't let evts be undefined, at worst, it should be an empty array.
                if (!evts)
                    evts = [];

                return {
                    monthMoment: monthMoment,
                    events: create({
                        events: evts,
                        month: monthMoment.month(),
                        year: monthMoment.year(),
                        weekdayNames: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
                    })
                }
            });

            dispatch(updateEvents(monthsToEvents ? monthsToEvents : []))
        }).catch(err => {
            dispatch(eventError(err));
        });
    }
}

export function getText(culture = "") {
    return (dispatch, getState: () => ICalendarAppState) => {
        dispatch(requestText());

        return CalendarApi.getText(culture).then(result => {
            dispatch(receiveText(result));
        }).catch(err => {
            dispatch(errorApiText(err));
        });
    }
}
export function getUpNext() {
    return (dispatch, getState: () => ICalendarAppState) => {
        var currentState = getState();
//        dispatch(requestUpNext());

        return CalendarApi.getUpNext(currentState.calendar, currentState.calendarSettings).then(result => {
            dispatch(updateUpNext(result));
        }).catch(err => {
            dispatch(errorApiText(err));
        });
    }
}
export function applyPromoCode() {
    return (dispatch, getState: () => ICalendarAppState) => {
        const state = getState();

        dispatch(requestPromoCodeApply());

        return CalendarApi.applyPromoCode(state.promoCode.promoCodeString).then(apiResult => {
            dispatch(receivePromoCodeApplyResponse(state.promoCode.promoCodeString, apiResult));
        }).catch(error => {
            dispatch(errorPromoCodeApply(error));
        });
    }
}